<!--
    The dropdown carries the errors so the trigger is outlined, but prints none: the message
    belongs to the choice, and is printed once below.
-->
<pace-dropdown-field
    [value]="selection()"
    (valueChange)="onSelectionChange($event)"
    [options]="options()"
    [maxSelections]="1"
    [placeholder]="placeholder()"
    [deselectable]="deselectable()"
    [errors]="errors()"
    [showErrorMessages]="false"
    [disabled]="disabled()"
    [readonly]="readonly()"
    [required]="required()"
    [ariaLabel]="ariaLabel()"
    (touchedChange)="touched.set(true)"
></pace-dropdown-field>
@if (hasErrorMessages()) {
    <div class="invalid-feedback d-block">
        @for (error of errors(); track error.kind) {
            <div>{{ error.message ?? error.kind }}</div>
        }
    </div>
}
